
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse-employers",
      function () {
        return require("private-next-pages/browse-employers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse-employers"])
      });
    }
  